// ============================================================================
// hvsin Route Contracts
//
// 本包仅包含路由服务的类型定义，不含实现。
// route-mod 以及业务 Mod 通过此包获取类型信息，
// 通过 hvsin 依赖注入机制获取实际 RouteService 实例。
//
// 设计目标：将 react-router 的直接引用封装在 route-mod 内，
// 业务模块通过 DI 获取路由能力，实现路由实现的解耦和可替换。
// ============================================================================
// ----------------------------------------------------------------------------
// 3. 接口标签常量
// ----------------------------------------------------------------------------
/** 路由服务接口标签 */
export const ROUTE_SERVICE_INTERFACE_TAG = 'IRouteService';
//# sourceMappingURL=index.js.map